// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ladderPointsStatement_statement__1i6cQ header {\n  display: flex;\n  justify-content: space-between;\n}\n.ladderPointsStatement_statement__1i6cQ table th:first-of-type {\n  width: 200px;\n}\n.ladderPointsStatement_statement__1i6cQ .ladderPointsStatement_table__3OMb0 {\n  height: 200px;\n}\n\n.ladderPointsStatement_statementInfo__2wJ1j {\n  padding: 2rem;\n  padding-right: 1rem;\n  text-align: justify;\n}\n\n.ladderPointsStatement_tooltipHeader__1y90N {\n  display: flex;\n  align-items: center;\n}\n.ladderPointsStatement_tooltipHeader__1y90N h3 {\n  margin: 0;\n  margin-right: 0.5rem;\n}\n\n.ladderPointsStatement_modalBody__26wOF {\n  height: 80vh;\n}", ""]);
// Exports
exports.locals = {
	"statement": "ladderPointsStatement_statement__1i6cQ",
	"table": "ladderPointsStatement_table__3OMb0",
	"statementInfo": "ladderPointsStatement_statementInfo__2wJ1j",
	"tooltipHeader": "ladderPointsStatement_tooltipHeader__1y90N",
	"modalBody": "ladderPointsStatement_modalBody__26wOF"
};
module.exports = exports;
